import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '@/views/HomePage.vue';
import CodingChallenges from '@/views/CodingChallenges.vue';
import Achievements from '@/views/MyAchievements.vue';
import ProjectsPage from '@/views/ProjectsPage.vue';
import OpenSourcePage from '@/views/OpenSourcePage.vue';
import AddPostPage from '@/views/AddPostPage.vue';

const routes = [
  { path: '/', name: 'Home', component: HomePage },
  { path: '/coding-challenges', name: 'CodingChallenges', component: CodingChallenges },
  { path: '/achievements', name: 'Achievements', component: Achievements },
  { path: '/projects', name: 'ProjectsPage', component: ProjectsPage },
  { path: '/open-source', name: 'OpenSourcePage', component: OpenSourcePage },
  { path: '/add-post', name: 'AddPostPage', component: AddPostPage },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
